import React from "react";
import classNames from "classnames";
import { CompanyTabsBarProps } from "./types";
import classes from "./company-tabs-bar.module.scss";

export const CompanyTabsBar = ({ activeTab, onTabChange }: CompanyTabsBarProps) => {
    return (
        <div className={classes["company-tabs"]}>
            <button
                className={classNames(classes["company-tabs__button"], {
                    [classes["company-tabs__button--active"]]: activeTab === "about"
                })}
                onClick={() => onTabChange("about")}
            >
                О компании
            </button>
            <button
                className={classNames(classes["company-tabs__button"], {
                    [classes["company-tabs__button--active"]]: activeTab === "ads"
                })}
                onClick={() => onTabChange("ads")}
            >
                Объявления
            </button>
        </div>
    );
};